function truncateName(name: string, CHARACTER_LIMIT: number = 11): string {
  if (name.length > CHARACTER_LIMIT) {
    return name.substring(0, CHARACTER_LIMIT) + '…';
  }
  return name;
}

export default truncateName;
